import React, { useEffect, useRef, useState } from "react";
import "./styles.css";
import { CSHeader, RippleButton } from "../../../Components/Atoms";
import { getLocalisedTime } from "../../../Library/datetime";
import { CS_IVR_NUMBER, ONE_DAY_MS } from "../../../Library/constants";
import { IncomingCallIcon } from "../../../Assets/images/svgs";
import { getStickerNotifications, getStickersByVid } from "../../../APIs";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useToast } from "@chakra-ui/react";
import PATHS from "../../../Routes/paths";
import { logFirebaseEvent } from "../../../firebase/logEventHelper";

const CsNotifications = () => {

  const [ notifications, setNotifications ] = useState([]);
  const [ searchParams ] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const Toast = useToast();
  const stickerMap = useRef({});

  const handleFetchNotifications = (stickers, vid) => {
    stickers.forEach(sticker => stickerMap.current[sticker.idx] = sticker.nm);
    getStickerNotifications({ stickerId: stickers.map(sticker => sticker.uniqueCode), vid: vid }, (err, notifs) => {
      if (err) Toast({ isClosable: true, description: "Unable to fetch notifications at the moment. Please try again later", position: "bottom", variant: "subtle", duration: 3000 });
      else setNotifications(notifs);
    });
  }

  useEffect(() => {
    document.body.classList.remove("Ev-Light-Theme-Container");

    let vid = location.state && location.state.vid;
    let vidFromParams = searchParams.get("vid");
    if (+vidFromParams) vid = +vidFromParams;
    if (!vid) navigate(`/${PATHS.CONTACT_STICKER}${PATHS.PROFILE_PAGE}`);

    if (!location.state || !location.state.stickers || !location.state.stickers.length) {
      getStickersByVid(vid, (err, data) => {
        if (err) {
          console.error(err);
          navigate(`/${PATHS.CONTACT_STICKER}${PATHS.PROFILE_PAGE}`);
        } else {
          if (!data || !data.stickers) return navigate(`/${PATHS.CONTACT_STICKER}${PATHS.PROFILE_PAGE}`);

          handleFetchNotifications(data.stickers, vid);
        }
      });
    } else handleFetchNotifications(location.state.stickers, vid);
  }, [ searchParams, Toast, location, navigate ]);

  const handleBackPress = () => {
    window.ReactNativeWebView.postMessage(JSON.stringify({ action: "go-back" }));
  }

  const handleCallBackClick = () => {
    logFirebaseEvent("CS_CALL_BACK_CLICK");
    window.open(`tel:0${CS_IVR_NUMBER}`);
  }

  return (
    <div className="cs-notifications">
      <CSHeader headerText="Notifications" onClick={handleBackPress} />

      <div className="notifications-container">
        { notifications.sort((notif1, notif2) => notif2.cts - notif1.cts).map((notif, index) => {
          const currentDay = new Date(notif.cts).toDateString();
          const previousDay = index > 0 ? new Date(notifications[index - 1].cts).toDateString() : null;

          const isToday = currentDay === new Date().toDateString();
          const isYesterday = currentDay === new Date(Date.now() - ONE_DAY_MS).toDateString();

          let dateLabel = isToday ? "Today" : (isYesterday ? "Yesterday" : currentDay);
          if (dateLabel === currentDay) dateLabel = new Date(dateLabel).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" })

          return (
            <div key={index} className="notif-row">
              {currentDay !== previousDay ? <p className="notif-date">{dateLabel}</p> : null}
              <p className="notif-text">
                <span>{getLocalisedTime(notif.cts)} <span>{stickerMap.current["1"] ? `(${stickerMap.current["1"]})` : ""}</span></span>
                {notif.message}

                {(!notif.callbackTs && notif.missedTs && (((Date.now() - notif.missedTs) / (1000 * 60)) < 60)) ? <RippleButton className="notif-callback-btn" onClick={handleCallBackClick}>
                  <IncomingCallIcon className="notif-callback-icon" />
                  Callback
                </RippleButton> : null}
              </p>
            </div>
          )
        }) }
      </div>
    </div>
  )
}

export default CsNotifications
